import React from 'react';

const SearchHeader = ( props ) => {

    return (
        <>
            { props.totalResults === 1 ?
                ( <p className="search-overlay-heading">Found <span className="search-overlay-heading__highlight">{props.totalResults}</span> result for <span className="search-overlay-heading__highlight">'{props.term}'</span> <i onClick={props.handleCloseOverlay} className="icon-close search-overlay-heading__close"></i></p> )
                :
                ( <p className="search-overlay-heading">Found <span className="search-overlay-heading__highlight">{props.totalResults}</span> results for <span className="search-overlay-heading__highlight">'{props.term}'</span> <i onClick={props.handleCloseOverlay} className="icon-close search-overlay-heading__close"></i></p>)
            }
            
        </>
    )

}

export default SearchHeader;